import gql from 'graphql-tag';

export default gql`
  mutation CreateGuest(
    $cellNumber: String!
    $firstName: String
    $lastName: String
    $email: String
    $dob: DateTime
    $residentialAddress: String
  ) {
    createStakeholder(
      data: {
        cellNumber: $cellNumber
        firstName: $firstName
        lastName: $lastName
        email: $email
        dob: $dob
        residentialAddress: $residentialAddress
        role: GUEST
      }
    ) {
      createdAt
      updatedAt
      id
      cellNumber
      firstName
      lastName
      email
      dob
      residentialAddress
      image {
        id
        original
        scaled
        thumbnail
      }
      role
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/CreateGuest.ts